export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const MARK_AS_LOGIN = "MARK_AS_LOGIN";
export const GET_SERVICES = "GET_SERVICES";
export const GET_CAREGIVER = "GET_CAREGIVER";
export const GET_BOOKINGS = "GET_BOOKINGS";
export const GET_PENDING_BOOKINGS = "GET_PENDING_BOOKINGS";
export const GET_ONGOING_BOOKINGS = "GET_ONGOING_BOOKINGS";
export const GET_COMPLETED_BOOKINGS = "GET_COMPLETED_BOOKINGS";
export const GET_CANCELLED_BOOKINGS = "GET_CANCELLED_BOOKINGS";
export const CLEAR_BOOKINGS = "CLEAR_BOOKINGS";
export const LOAD_MORE_BOOKINGS = "LOAD_MORE_BOOKINGS";
export const LOAD_MORE_PENDING_BOOKINGS = "LOAD_MORE_PENDING_BOOKINGS";
export const LOAD_MORE_ONGOING_BOOKINGS = "LOAD_MORE_ONGOING_BOOKINGS";
export const LOAD_MORE_COMPLETED_BOOKINGS = "LOAD_MORE_COMPLETED_BOOKINGS";
export const LOAD_MORE_CANCELLED_BOOKINGS = "LOAD_MORE_CANCELLED_BOOKINGS";
export const GET_STATES = "GET_STATES";
export const GET_PAYMENT_METHODS = "GET_PAYMENT_METHODS";
export const ADD_PAYMENT_METHOD = "ADD_PAYMENT_METHOD";
export const REMOVE_PAYMENT_METHOD = "REMOVE_PAYMENT_METHOD";
export const CLEAR_PAYMENT_METHODS = "CLEAR_PAYMENT_METHODS";
export const GET_CHAT = "GET_CHAT";
export const LOAD_MORE_CHAT = "LOAD_MORE_CHAT";
export const CLEAR_CHAT = "CLEAR_CHAT";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const READ_ALL_NOTIFICATIONS = "READ_ALL_NOTIFICATIONS";
export const LOAD_MORE_NOTIFICATIONS = "LOAD_MORE_NOTIFICATIONS";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const START_LOADER = "START_LOADER";
export const STOP_LOADER = "STOP_LOADER";
export const GET_FAVORITES = "GET_FAVORITES";
export const CLEAR_FAVORITES = "CLEAR_FAVORITES";
export const GET_WALLET_HISTORY = "GET_WALLET_HISTORY";
export const CLEAR_WALLET_HISTORY = "CLEAR_WALLET_HISTORY";
export const INCREASE_NOTIFICATION = "INCREASE_NOTIFICATION";
